import React, { Component } from 'react'
import ButtonLinkExternal from '../generic/ButtonLinkExternal'
import facebookIcon from '../../images/facebook-light.svg'
import twitterIcon from '../../images/twitter-light.svg'
import linkedinIcon from '../../images/linkedin-light.png'
export const moment = require('moment');

const ButtonLogo = ButtonLinkExternal.extend`
	padding: 8px 25px;
  border-radius: 26px;
  margin-right: 10px;
  margin-bottom: 8px;

  div {
    display: flex;
    align-items: center;
  }

  img {
    width: 32px;
    height: 32px;
    border-radius: 5px;
    margin-right: 10px;
  }
  title {

  }
`

class SocialSharing extends Component {
	render() {
		const { event, host, fromHost } = this.props

		const eventURL = `${process.env.REACT_APP_BASE_URL}/event/${event.token}`

		let formattedDate = null

    if (event.invitation_date) {
      let dateComponents = event.invitation_date.split("-")

      let date = new Date(dateComponents[0], dateComponents[1]-1, dateComponents[2])
      formattedDate = moment(date).format('dddd, MMMM D')
    }
		
		let message
		if (fromHost) {
			message = "At our #onthetableBC event we will be talking about " + event.topic + " on " + formattedDate + ". RSVP to join if you can!"
		} else {
			message = "At this public #onthetableBC event, people are talking about " + event.topic + " on " + formattedDate + ". RSVP to join if you can!"
		}

		let socialPost = {
      text: message,
      url: eventURL,
    }

    Object.keys(socialPost).map(function(key, index) {
      socialPost[key] = encodeURIComponent(socialPost[key]);
    });

		return (
			<div>
        <ButtonLogo small secondary href={"https://twitter.com/intent/tweet?text=" + socialPost.text + "&url=" + socialPost.url} target="_blank"><div><img src={twitterIcon} /><span className="title">Post to Twitter</span></div></ButtonLogo>
        <ButtonLogo small secondary href={"https://www.facebook.com/sharer/sharer.php?u=" + socialPost.url} target="_blank"><div><img src={facebookIcon} /><span className="title">Post to Facebook</span></div></ButtonLogo>
        <ButtonLogo small secondary href={"http://www.linkedin.com/shareArticle?mini=true&url=" + socialPost.url + "&summary=" + socialPost.text} target="_blank"><div><img src={linkedinIcon} /><span className="title">Post to LinkedIn</span></div></ButtonLogo>
      </div>
		)
	}
}

export default SocialSharing